export const CALC_LANG = {
  services: {
    power: 'Ökostrom',
    gas: 'Gas',
    heatflow: 'Wärmestrom',
    dynamic_strom: 'Dynamischer Ökostrom',
  },
  customer_options: {
    b2c: 'Privatkunde',
    b2b: 'Geschäftskunde',
  },
  labels: {
    persons_count: 'Personen im Haushalt',
    house_size: 'Anzahl der m² in deinem Haushalt',
    business_size: 'Größe des Unternehmens',
    consumption: 'Jahresverbrauch in kWh',
    heatflow_type: 'Ich heize mit einer Wärmepumpe.',
  },
  tooltip: {
    meter_type: {
      title: 'Mehr Informationen',
      content:
        'Voraussetzung für den MeinWärmestromTarif ist, dass dein Energieverbrauch für den Wärmestrom separat dargestellt werden kann. Eine Übersicht über die möglichen Zählervarianten findest du <a href="/waermestrom/waermestromzaehler">hier</a>.',
    },
  },
  buttons: {
    power: 'Strompreis berechnen',
    gas: 'Gaspreis berechnen',
    heatflow: 'Wärmestrompreis berechnen',
    dynamic_strom: 'Strompreis berechnen',
  },
};
